<template>
  <div class="outcomes-research-wrapper"><slot></slot></div>
</template>

<script>
const TOUCH_ICON_LINK = "apple-touch-icon.png";
const FAVICON_LINK = "favicon-32x32.png";

export default {
  props: {
    _title: { type: String },
  },
  data() {
    return {
      content:
        "Clinical Outcomes Research at Washington University in St Louis",
    };
  },
  head: {
    title: function() {
      return {
        inner: this._title,
        complement: "WashU Outcomes Research",
      };
    },
    meta: function() {
      return [
        { name: "application-name", content: this._title },
        { name: "description", content: this.content },

        { name: "twitter:title", content: this._title },
        { n: "twitter:description", c: this.content },

        { name: "og:description", content: this.content },
        { name: "og:title", content: this._title },
        {
          p: "og:image",
          c: "https://cpb-us-w2.wpmucdn.com/sites.wustl.edu/dist/8/1082/files/2017/11/medical-school-featured-05-24tco0b.jpg",
        },
      ];
    },
    link: [
      {
        rel: "icon",
        href: require(`./assets/${FAVICON_LINK}`),
      },
      {
        rel: "apple-touch-icon",
        href: require(`./assets/${TOUCH_ICON_LINK}`),
        type: "image/png",
      },
    ],
  },
};
</script>

<style>
.outcomes-research-wrapper {
  display: flex;
  flex-direction: column;
}
</style>
